import React from "react";

const SuspenseSpinner = () => {
  return (
    <div>
      <div className="spinner-wrapper">
        <div className="donut"></div>
      </div>
    </div>
  );
};

export default SuspenseSpinner;
